import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const NEWSLETTER_TOPICS = [
  { key: "singole", label: "Nuovi arrivi" },
  { key: "preordini", label: "Preordini" },
  { key: "tornei", label: "Tornei" },
  { key: "eventi", label: "Eventi" },
];

export const NEWSLETTER_CHANNELS = [
  { key: "tcg", label: "Carte TCG" },
  { key: "esports", label: "eSports" },
];

// Form condiviso: stesso metodo per il popup dei visitatori e per la scheda nel profilo.
export default function NewsletterForm({ defaultEmail = "", lockEmail = false, initialGames = [], initialTopics = [], submitLabel = "Iscriviti e ricevi il buono", onSuccess }) {
  const [email, setEmail] = useState(defaultEmail);
  const [games, setGames] = useState(initialGames);
  const [topics, setTopics] = useState(initialTopics);
  const [busy, setBusy] = useState(false);

  const toggle = (setList, v) => setList((prev) => (prev.includes(v) ? prev.filter((x) => x !== v) : [...prev, v]));

  const submit = async (e) => {
    e.preventDefault();
    if (!topics.length) { toast.error("Scegli almeno un argomento su cui vuoi essere avvisato"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim(), games, topics });
      onSuccess?.(data);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Iscrizione non riuscita, riprova");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="newsletter-form">
      <div>
        <label className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 block mb-2">La tua email</label>
        <input
          type="email"
          required
          value={email}
          disabled={lockEmail}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="nome@email.it"
          data-testid="newsletter-email-input"
          className="w-full bg-[#050505] border border-white/10 rounded-lg px-4 py-3 text-sm text-white placeholder:text-zinc-600 focus:border-red-600 focus:outline-none disabled:opacity-60"
        />
      </div>
      <div>
        <label className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 block mb-2">Cosa segui <span className="text-zinc-600 normal-case tracking-normal">(puoi scegliere entrambe — nessuna scelta = tutto)</span></label>
        <div className="flex flex-wrap gap-2" data-testid="newsletter-games">
          {NEWSLETTER_CHANNELS.map((c) => (
            <button
              type="button"
              key={c.key}
              data-testid={`newsletter-game-${c.key}`}
              onClick={() => toggle(setGames, c.key)}
              className={`px-3.5 py-2 rounded-full text-xs font-bold uppercase tracking-wide border transition-colors ${games.includes(c.key) ? "bg-red-600 border-red-600 text-white" : "border-white/15 text-zinc-400 hover:border-red-600/60 hover:text-white"}`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <label className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 block mb-2">Avvisami su</label>
        <div className="flex flex-wrap gap-2" data-testid="newsletter-topics">
          {NEWSLETTER_TOPICS.map((t) => (
            <button
              type="button"
              key={t.key}
              data-testid={`newsletter-topic-${t.key}`}
              onClick={() => toggle(setTopics, t.key)}
              className={`px-3.5 py-2 rounded-full text-xs font-bold uppercase tracking-wide border transition-colors ${topics.includes(t.key) ? "bg-red-600 border-red-600 text-white" : "border-white/15 text-zinc-400 hover:border-red-600/60 hover:text-white"}`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <button
        type="submit"
        disabled={busy}
        data-testid="newsletter-submit-button"
        className="w-full bg-red-600 hover:bg-red-700 disabled:opacity-60 text-white font-display font-bold uppercase tracking-wide text-sm px-6 py-3.5 rounded-full transition-all active:scale-[0.97]"
      >
        {busy ? "Iscrizione in corso..." : submitLabel}
      </button>
      <p className="text-[10px] text-zinc-600 leading-relaxed">Niente spam: ricevi solo quello che hai scelto, e puoi annullare quando vuoi. Il buono arriva subito via email.</p>
    </form>
  );
}
